import { boolean, InferType, number, object, string } from 'yup';

export const vehicleMakeSchema = object({
  id: number().required(),
  name: string().required(),
  is_popular: boolean(),
});

export const vehicleModelSchema = object({
  id: number().required(),
  name: string().required(),
  type: string().nullable(),
  is_popular: boolean(),
});

export type VehicleMakeDTO = InferType<typeof vehicleMakeSchema>;
export type VehicleModelDTO = InferType<typeof vehicleModelSchema>;

export function mapVehicleType(value: string) {
  return value === 'pickup_4_doors'
    ? '4_door_pickup'
    : value === 'coupe_2_doors'
      ? '2_door_coupe'
      : value;
}

export const VALID_VEHICLE_TYPES = [
  'sedan',
  'coupe_2_doors',
  'suv',
  'pickup',
  'pickup_4_doors',
  'van',
];
